export const findChipColors = (percentage: number) => {
  if (percentage <= 10) {
    return 'nc_progress-roadmap-table-chip-green-light';
  }
  if (percentage > 10 && percentage < 30) {
    return 'nc_progress-roadmap-table-chip-green-light-middle';
  }
  if (percentage >= 30 && percentage < 50) {
    return 'nc_progress-roadmap-table-chip-green-medium';
  }
  if (percentage >= 50 && percentage < 70) {
    return 'nc_progress-roadmap-table-chip-green-medium-middle';
  }
  if (percentage >= 70 && percentage < 90) {
    return 'nc_progress-roadmap-table-chip-green-dark';
  }
  if (percentage >= 90) {
    return 'nc_progress-roadmap-table-chip-green-dark-strong';
  }
};

export const getColorForValue = (
  value: number,
  min: number,
  max: number,
  minColor: string,
  maxColor: string,
  type: 'green' | 'yellow' | 'grey',
) => {
  if (max === min) return { backgroundColor: minColor, color: type === 'green' ? '#008158' : '#393939' }; // Avoid division by zero if all values are the same
  const normalized = (value - min) / (max - min);
  const minRGB = hexToRgb(minColor);
  const maxRGB = hexToRgb(maxColor);

  if (!minRGB || !maxRGB) return { backgroundColor: minColor, color: type === 'green' ? '#008158' : '#393939' };
  const interpolatedRGB = {
    r: Math.round(minRGB.r + normalized * (maxRGB.r - minRGB.r)),
    g: Math.round(minRGB.g + normalized * (maxRGB.g - minRGB.g)),
    b: Math.round(minRGB.b + normalized * (maxRGB.b - minRGB.b)),
    a: minRGB.a + normalized * (maxRGB.a - minRGB.a),
  };

  let color = '';
  if (type === 'green') color = interpolatedRGB.a > 0.47 ? '#fff' : '#008158';
  if (type === 'grey') color = interpolatedRGB.a > 0.47 ? '#fff' : '#393939';
  if (type === 'yellow') color = '#393939';

  return {
    backgroundColor: `rgba(${interpolatedRGB.r}, ${interpolatedRGB.g}, ${interpolatedRGB.b}, ${interpolatedRGB.a})`,
    color: color,
  };
};

// Helper function: Convert HEX to RGBA
const hexToRgb = (hex: string): { r: number; g: number; b: number; a: number } | null => {
  let r = 0,
    g = 0,
    b = 0,
    a = 1;

  // Expand shorthand hex (#RGB → #RRGGBB)
  if (hex.length === 7 || hex.length === 9) {
    r = parseInt(hex.slice(1, 3), 16);
    g = parseInt(hex.slice(3, 5), 16);
    b = parseInt(hex.slice(5, 7), 16);
    if (hex.length === 9) {
      a = parseInt(hex.slice(7, 9), 16) / 255;
    }
  } else if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else {
    return null;
  }

  return { r, g, b, a };
};
